module.exports = __webpack_public_path__ + "static/media/4seg-login-image.854a42e5.png";